<template>
   <header id="admin_header">
      <h1 id="logo">
         <img src="@/assets/img/layout/admin_logo.svg" alt="Admin Logo">
      </h1>

      <div class="lnb">
         <ul>
            <li v-for="( item, index ) in lnbData" :key="index" :class="{ on: openMenuIdx === index }" >
               <a href="javascript:void(0);" class="dp1" @click="depthCurrentHandler(item, index)">{{ item.name }}</a>
               <ul class="dp2">
                  <li v-for=" ( item2, index2 ) in item.children " :key="index2" :class="{ active: activePath === item2.path}" >
                     <a href="javascript:void(0);" @click="depth2CHandler(item2.path)">{{ item2.name }}</a>
                  </li> 
               </ul>
            </li>
         </ul>
      </div>
   </header>

</template>

<script>
   //import { lnbData } from "@/data/GnbMenuList"
   import axios from 'axios'

   export default {
      name: "AdminLnb",
      data() {
         return {
            clickEvent1: 0,      // depth1 Click Event
            clickEvent2: 0,      // depth2 Click Event
            lnbData: [],
            openMenuIdx: null,   // 열린 1depth index (DOM 대신 data로 관리)
            activePath:  null,   // 활성 2depth path (DOM 대신 data로 관리)
         }
      },
      created() {
         //this.getMenuList();
          // lnbData 없을 때만 API 호출
          if (this.$store.state.menuStore.maneList.length === 0) {
            this.getMenuList();
          } else {
            // 이미 store에 있으면 그대로 사용
            this.lnbData = this.$store.state.menuStore.maneList;
          }

          // 현재 URL 기준으로 열린 메뉴 복원
          this.restoreOpenMenu();
      },
      methods: {
         // depthCurrentHandler : function(path,e){
         //    let depth1 = document.querySelectorAll('.lnb > ul > li');
         //    let target = e.target.parentElement;
         //    if(target.className != "on"){
         //       for ( let i = 0; i < depth1.length; i++){ // 뎁스 갯수 만큼
         //          depth1[i].classList.remove('on');
         //       }
         //       target.classList.add('on');
         //    }else{
         //       target.classList.remove('on');
         //    }
         //
         //    if(path != "" && path != null){
         //       this.$router.push(path);
         //    }
         // },
          depthCurrentHandler(item, index) {
            // ✅ DOM 직접 조작 대신 data로 관리
            this.openMenuIdx = this.openMenuIdx === index ? null : index;

            if (item.path) {
              this.$router.push(item.path);
            }
          },
         // depth2CHandler : function(path,e){
         //    let depth2 = document.querySelectorAll('.lnb .dp2 > li');
         //    let target = e.target.parentElement;
         //
         //    if(target.className != "active"){
         //       for ( let i = 0; i < depth2.length; i++){
         //          depth2[i].classList.remove('active');
         //       }
         //       target.classList.add('active');
         //    }else{
         //       target.classList.remove('active');
         //    }
         //
         //    if(path != "" && path != null){
         //       this.$store.dispatch('commonStore/setCommonStoreInit');
         //       this.$router.push(path);
         //    }
         // },
          depth2CHandler(path) {
            // DOM 직접 조작 대신 data로 관리
            this.activePath = path;

            if (path) {
              this.$store.dispatch('commonStore/setCommonStoreInit');
              this.$router.push(path);
            }
          },
          restoreOpenMenu() {
            // 현재 URL 기준으로 열린 메뉴 자동 복원
            const currentPath = this.$route.path;
            this.lnbData.forEach((menu, index) => {
              const matched = menu.children.some(c => c.path === currentPath);
              if (matched) {
                this.openMenuIdx = index;
                this.activePath  = currentPath;
              }
            });
          },
        // getMenuList(){
        //
        //     let param = {
        //        mngrMbrId : this.$store.state.mngrMbrMngt.mngrMbrId
        //     }
        //
        //     axios.post("/api/admin/getMenuList",param)
        //     .then((res) => {
        //         console.log("@@@@ 메뉴리스트 : %o",res);
        //         if(res.data.result == "0"){
        //
        //             let menuInfo = this.buildMenuTree(res.data.menuList);
        //             this.lnbData = menuInfo;
        //
        //         }else{
        //             alert("메뉴리스트를 불러오는데 실패했습니다.");
        //         }
        //     })
        //     .catch((err) => console.log(err));
        // },
        getMenuList() {
          const param = {
            mngrMbrId: this.$store.state.mngrMbrMngt.mngrMbrId
          };

          axios.post("/api/admin/getMenuList", param)
              .then((res) => {
                if (res.data.result == "0") {
                  const menuInfo = this.buildMenuTree(res.data.menuList);

                  // ✅ store에 저장해서 재호출 방지
                  this.$store.commit('menuStore/SET_LNB_DATA', menuInfo);
                  this.lnbData = menuInfo;

                  // ✅ 데이터 세팅 후 현재 메뉴 복원
                  this.restoreOpenMenu();
                } else {
                  alert("메뉴리스트를 불러오는데 실패했습니다.");
                }
              })
              .catch((err) => console.log(err));
        },
        buildMenuTree(rows) {
          const map  = {};
          const tree = [];

          rows.forEach(row => {
            if (!map[row.menu_id]) {
              map[row.menu_id] = {
                name:     row.menu_name,
                path:     row.menu_path || '',
                children: []
              };
            }
            if (row.child_id) {
              map[row.menu_id].children.push({
                name: row.child_name,
                path: row.child_path
              });
            }
          });

          Object.values(map).forEach(menu => tree.push(menu));
          return tree;
        }
      }
   }
</script>